import { useUiStore } from '../../stores/ui'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

const stateMeta = {
  connected: { label: '实时链路正常', cls: 'bg-success shadow-[0_0_10px_var(--success-soft)]' },
  connecting: { label: '实时链路连接中', cls: 'bg-warning' },
  degraded: { label: '实时链路降级', cls: 'bg-warning' },
  offline: { label: '实时链路离线', cls: 'bg-muted-foreground/50' },
} as const

export function RealtimeDot() {
  const state = useUiStore((s) => s.realtimeState)
  const meta = stateMeta[state]
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="flex cursor-default items-center gap-2 text-[11px] text-muted-foreground">
          <span className={`size-2 rounded-full ${meta.cls} ${state === 'connected' ? 'animate-pulse' : ''}`} />
          <span className="hidden lg:inline">{meta.label}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent>
        MQTT over WebSocket（ws://localhost:8083/mqtt）· 当前状态：{meta.label}
      </TooltipContent>
    </Tooltip>
  )
}
